<template>
  <div
    v-if="flow.showStepNav"
    class="flex items-center gap-2"
  >
    <UButton
      v-if="primary"
      size="lg"
      class="flex-1 justify-center"
      :icon="primary.icon"
      :to="primary.to"
      :target="primary.external ? '_blank' : undefined"
      :rel="primary.external ? 'noopener' : undefined"
      :external="!!primary.external"
      :loading="primary.loading"
      :disabled="primary.disabled"
      @click="primary.action?.()"
    >
      {{ primary.label }}
    </UButton>

    <UButton
      v-if="flow.canGoBack"
      variant="soft"
      color="neutral"
      size="lg"
      trailing-icon="i-lucide-chevron-left"
      class="shrink-0"
      :disabled="flow.submitting || flow.otpVerifying"
      @click="flow.goBack"
    >
      مرحلهٔ قبل
    </UButton>
  </div>
</template>

<script setup lang="ts">
import type { useBookingFlow } from '~/composables/useBookingFlow'

const props = defineProps<{
  flow: ReturnType<typeof useBookingFlow>
}>()

type PrimaryAction = {
  label: string
  icon?: string
  to?: string
  external?: boolean
  loading?: boolean
  disabled?: boolean
  action?: () => void
}

/** The main call to action of the current step, pinned in the footer. */
const primary = computed<PrimaryAction | null>(() => {
  const flow = props.flow
  if (flow.step === 'quiz') {
    if (flow.quizFailed) {
      return {
        label: 'درخواست مشاوره',
        icon: 'i-lucide-stethoscope',
        to: '/#consultation',
      }
    }
    return {
      label: 'ادامه',
      loading: flow.quizSubmitting,
      action: flow.submitReadinessQuiz,
    }
  }
  if (flow.step === 'slot') {
    return {
      label: 'ادامه',
      disabled: !flow.selectedSlot,
      action: flow.goPhone,
    }
  }
  if (flow.step === 'otp') {
    return flow.otpSent
      ? {
          label: 'تأیید و ادامه',
          loading: flow.otpVerifying,
          disabled: flow.otpCode.join('').length !== 6,
          action: flow.verifyOtp,
        }
      : {
          label: 'ارسال کد تأیید',
          icon: 'i-lucide-message-square-lock',
          loading: flow.otpSending,
          disabled: !flow.phoneComplete,
          action: flow.sendOtp,
        }
  }
  if (flow.step === 'confirm') {
    return {
      label: flow.submitLabel,
      icon: flow.payMethod === 'gateway' ? 'i-lucide-credit-card' : 'i-lucide-check',
      loading: flow.submitting,
      disabled: !flow.identityComplete,
      action: flow.submitBooking,
    }
  }
  if (flow.step === 'success' && flow.ticket?.visitType === 'virtual') {
    return {
      label: 'ورود به ویزیت مجازی',
      icon: 'i-lucide-video',
      to: '/virtual-visit',
    }
  }
  return null
})
</script>
